﻿$.fn.dxCtrlBuilderEmailStyleButton = function custom_dxCtrlBuilderEmailStyleButton(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlbuilderemailstylebutton dx-ctrl");
        this.createInstance(new cdxCtrlBuilderEmailStyleButton(this, option));
    }
    return this;
}

window.cdxCtrlBuilderEmailStyleButton = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    function mConstruit() {
        container.empty()

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Forme du bouton:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleRadius({
            allowDefaut: option.allowDefaut,
            radiusTopRight: option.value["border-top-right-radius"],
            radiusTopLeft: option.value["border-top-left-radius"],
            radiusBottomRight: option.value["border-bottom-right-radius"],
            radiusBottomLeft: option.value["border-bottom-left-radius"],
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Largeur du bouton:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleLargeur({
            allowDefaut: option.allowDefaut,
            value: option.value.width.toString().replace("%", ""),
            onValueChanged: function (value) {
                var newValue = value + ((value.toString().length > 0) ? "%" : "")
                option.onValueChanged({ values: [{ prop: "width", value: newValue, oldValue:option.value.width }] })
                option.value.width = newValue
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Marge du bouton:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStylePadding({
            type: "padding",
            allowDefaut: true,
            padTop: option.value["padding-top"].replace("px", ""),
            padBottom: option.value["padding-bottom"].replace("px", ""),
            padLeft: option.value["padding-left"].replace("px", ""),
            padRight: option.value["padding-right"].replace("px", ""),
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Bordure du bouton:</div>").appendTo(container)
        $("<div/>").appendTo(container).dxCtrlBuilderEmailStyleBordure({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            allowDefaut: option.allowDefaut,
            borderWidth: option.value["border-width"],
            borderStyle: option.value["border-style"],
            borderColor: option.value["border-color"],
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Couleur bouton:</div>").appendTo(container)
        $("<div  style='margin:5px 0;'/>").appendTo(container).dxCtrlColorPicker({
            value: option.value["background-color"],
            titlePaletteSelect: "Couleur dans votre email",
            getPaletteSelect: option.dxBuilderEmailPage.mGetLstColor,
            onValueChanged: function (e) {
                var newValue= e.value
                option.onValueChanged({ values: [{ prop: "background-color", value: newValue, oldValue: option.value["background-color"]  }] })
                option.value["background-color"] = newValue
            }
        })

        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;margin-top:10px;' class=''>Style texte du bouton:</div>").appendTo(container)
        dxWidgetFont = $("<div style='padding:10px 0;'/>").appendTo(container).dxCtrlBuilderEmailStyleFont({
            showAlign:true,
            value: option.value,
            allowDefaut: option.allowDefaut,
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            onValueChanged: function (e) {
                option.onValueChanged(e)
            }
        }).dxCtrlBuilderEmailStyleFont("instance")
    }

    this.element = function () { return container }

    mConstruit();
}